import { Tabs } from "antd";
import _ from 'lodash';
import moment from 'moment';
import React from "react";
import { connect } from "react-redux";
import upArrow from "../../../../../../assets/icons/short-arrow-t-green.svg";
import { Content, DataHeading } from "../../../../../../CommonComponents/commonStyles";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import { addSuccessor, errorVariable, resetLegacy, saveOptionData, saveSuccessorValues, shouldClose, showRemainingPercentage, updateLegacyFormValid } from "../../../../actions";
import Constants from "../../../../constants";
import Popup from "../../../Step1Setup/Components/Popup/Popup";
import { PillButtonAdd } from "../../../Step1Setup/styles";
import { ImageWrap, ShowLessWrapMargin } from "../AccordionContent/styles";
import CharityForm from "../CharityForm";
import Form from "../Form";
import { PillButtonSelect, UnderlinelinkRemove } from "../LegacyAccordions/styles";
import { Err, PillButtonAddSpaceAdd, PillButtonGreen, PillButtonGreenWrap, TabsWrapper, TitleWrap } from "./styles";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
const TabPane = Tabs.TabPane;
let invalidTab = [];
let checkStateVariable;
class TabsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 1;
    const panes = [
      {
        key: "1"
      }
    ];
    this.state = {
      activeKey: panes[0].key,
      panes,
      removed: 1,
      activeTab: 1,
      show: false,
      saved: "none",
      remove: false,
      tabData: props.optionId === 1 || props.optionId === 2 ? props.successorData : props.charityData,
      allFormsValid: [],
      showFormValidation: false,
      isValidSet: [],
      charityAllocPercent:props.contentKey === "multiCharity"? false:true,
      indexValue: false
    };

    this.removePopupContent = {
      heading: "Remove Information",
      line1: "Are you sure you want to remove information?",
      line2: "Do you want to continue?",
      continue: "continue",
      cancel: "No, take me back",
      type: "removeInfo"
    };
    this.removePopupContentAppoint = {
      ...this.removePopupContent, ...{
        heading: "Remove successor",
        line1: "Are you sure you want to remove successor?",
        type: "remove"
      }
    };
    this.removePopupContentCreate = {
      ...this.removePopupContentAppoint, ...{
        heading: "Remove successor account",
        line1: "Are you sure you want to remove successor account?",
      }

    };
    this.removePopupContentCharity = {
      ...this.removePopupContentAppoint, ...{
        heading: "Remove charity",
        line1: "Are you sure you want to remove the charity?",
      }
    };
  }
 
  componentWillReceiveProps(nextProps) {    
    this.setState({
      tabData: nextProps.optionId === 1 || nextProps.optionId === 2 ? nextProps.successorData : nextProps.charityData,
      showFormValidation: false
    });
  }

  componentDidUpdate(preProps){
    if(this.props.legacyFormValid && (preProps.legacyFormValid !== this.props.legacyFormValid)){
      this.setState(
        {
          ...this.state,
          allFormsValid: []
        },
        () => {
          this.props.updateLegacyFormValid(this.props.contentKey);
        }
      );
    }
  }
  closeModal = () => {
    this.setState({
      show: false
    });
  };
  closeModalInside = () => {
    this.setState({
      remove: false
    });
  };

  handleSave = successors => {    
    try {
      let percentage = this.props.percentage;
      const { allFormsValid, tabData } = this.state;      
      let charityTotalPercent =0;
      if(this.props.contentKey === "multiCharity"){
        
        for(let i=0;i<tabData.length;i++){
          let per =tabData[i].charityAllocPercent
          charityTotalPercent +=per? parseFloat(per) :0
        }
        this.setState({...this.state,charityAllocPercent:charityTotalPercent ===100?true:false},()=>{
          this.validateFormData(percentage, tabData, allFormsValid)
        })  
      }else{
        this.validateFormData(percentage, tabData, allFormsValid)
      }
      initiateTracking("buttonStep", Constants.PAGE_TITLE, this.props.head, "Save and Continue");
    } catch (error) {
      recordError(error);
    }
  };
  validationForSuccessors = (tabData) => {
    let successorsObj = [];
    let newSuccessorInfo = [];
    
    if(this.props.accountAdvisors) {
      for (let i = 0; i < this.props.accountAdvisors.length; i++) {
        let Obj = {};
        Obj['index'] = i + 1;
        Obj['firstName'] = this.props.accountAdvisors[i].firstName.toLowerCase();
        Obj['lastName'] = this.props.accountAdvisors[i].lastName.toLowerCase();
        Obj['dateofbirth'] = this.props.accountAdvisors[i].dob;
        successorsObj.push(Obj);
      }
    }
    if (tabData) {
      for (let i = 0; i < tabData.length; i++) {
        let newObj = {};
        newObj['index'] = i + 1;
        newObj['firstName'] = tabData[i].firstName.toLowerCase();
        newObj['lastName'] = tabData[i].lastName.toLowerCase();
        newObj['dateofbirth'] = parseInt(tabData[i].dob);
        newSuccessorInfo.push(newObj);
      }
      let invalidTabVariable;
      if(this.props.accountAdvisors) {
        if(this.props.accountAdvisors.length) {
          {
            invalidTabVariable = newSuccessorInfo.map((e, i) => {
              let tempArray = successorsObj.find(element => (element.firstName === e.firstName && element.lastName === e.lastName && moment(element.dateofbirth).format("MM/DD/YYYY") === moment(e.dateofbirth).format("MM/DD/YYYY")))
              if (tempArray) {
                return i + 1;
              } else {
                return null
              }
            })
            if (invalidTabVariable.length) {
              invalidTabVariable = invalidTabVariable.filter(item => item)
              return invalidTab = [...invalidTabVariable];
            } else {
              return invalidTab = "";
            }  
          }
        }
      }
    }        
  }  
  validateFormData = (percentage, tabData, allFormsValid)=>{
    if(this.props.optionId === 1 || this.props.optionId === 2) { this.validationForSuccessors(tabData); }

    if (!Number(percentage)) {
      this.props.validatePercentForm();
    } else if (!this.checkFormsValid(allFormsValid) || !this.state.charityAllocPercent) {
      this.props.saveOptionData(false);
      this.setState({
        showFormValidation: true
      }, () => {
        this.checkValidation(tabData);
      });
    } else if(invalidTab) {
      if(invalidTab.length) {
        this.props.errorVariable(true);
        this.setState({
          indexValue: true
        }, () => {          
          checkStateVariable = this.state.indexValue;
          this.checkValidation(tabData);
        })
      }     
      else {
        if(this.state.indexValue) {    
          this.setState({
            indexValue: false          
          }, () => {
            checkStateVariable = this.state.indexValue;
            this.checkValidation(tabData);
            this.props.errorVariable(false);
          })
        } else {
          checkStateVariable = false;
          this.checkValidation(tabData);
        }
      }
    }    
  }
  checkValidation = (tabData) => {
    this.props.saveSuccessorValues({
      successorInfo: tabData,
      key: this.props.contentKey
    });
    this.props.shouldClose({
      shouldClose: false
    });
    if (this.props.optionId !== 1 && this.props.optionId !== 2 && !this.state.showFormValidation) {
      this.props.handleChange();
    } else {
      if (!checkStateVariable && !this.state.showFormValidation) {
        this.props.handleChange();
      }
    }
    this.props.showRemainingPercentage({
      showRemainingPercentage: true,
      key: this.props.contentKey,
      value: true
    });
  }

  handleRemove = () => {
    this.setState({
      show: !this.state.show,
      type: "remove"
    });

    this.handleRemoveSuccessor(this.props.contentKey);
  };

  handleRemoveState = () => {
    this.setState({
      remove: true
    });
  };
  handleRemoveModal = () => {
    this.setState({
      remove: false,
      saved: "cancelled",
      activeKey:"1"
    });
    this.props.handleRemove();
  };

  onRemove = () => {
    this.setState({
      show: !this.state.show,
      type: "remove"
    });
  }

  handleAddSuccessor = (contentKey, successors) => {    
    let successorDetails = successors.filter(i => i.selected === false);
    successors = successors.filter(i => i.selected === true);
    try {
      let element = document.getElementById(contentKey);
      let headerOffset = 45;
      let elementPosition = element.getBoundingClientRect().height;
      let offsetPosition = elementPosition - headerOffset;
      window.scrollBy(0,offsetPosition * -1)
      const { panes, allFormsValid } = this.state;
      let valid = [...allFormsValid]
      for(let i = 0; i < successors.length; i++){
        if(valid[i] !== false){
          valid[i] = true;
        }
      }
  
      this.newTabIndex = successors ? successors.length + 1 : 2;
      const activeKey = this.newTabIndex.toString();
      panes.push({
        key: activeKey
      });   

      successors = [...successorDetails, ...successors];

      this.setState({ panes, activeKey,allFormsValid:valid,showFormValidation:false },()=>{
        this.props.addSuccessor({
          contentKey,
          successors,
          successionDetailId: `${getPrimaryAccount().userId}${contentKey}${this.newTabIndex}`
        });
      });
    } catch (error) {
      recordError(error);
    }
  };

  onChange = activeKey => {
    this.setState({ activeKey });
  };

  handleRemoveSuccessor = (contentKey) => {
    let { activeKey, tabData } = this.state;
    let legacyValues = [...tabData], nextActiveKey;

    if (activeKey === "1") {
      nextActiveKey = activeKey;
    } else {
      nextActiveKey = activeKey - 1;
    }

    if(legacyValues[activeKey - 1].successionDetailId.includes(contentKey)) {
       // activeKey - 1 as index starts from 0
      legacyValues.splice(parseInt(activeKey) - 1, 1);
    } else {
      legacyValues[activeKey - 1].selected = false;
      if(contentKey === Constants.MULTI_CHARITY) {
        legacyValues[activeKey - 1].charityAllocPercent = "0";
      }
    }
    
    let allFormsValid = this.state.allFormsValid
    allFormsValid.splice(parseInt(activeKey) - 1, 1);
    this.setState({
      activeKey: nextActiveKey.toString(),
      removed: this.state.removed + 1,
      allFormsValid
    });
    this.props.saveSuccessorValues({
      successorInfo: legacyValues,
      key: contentKey
    });
  };

  changeHandler = tabIndex => {
    this.setState({ activeTab: tabIndex });
  };

  checkFields = () => {
    let hasFormValue = false;
    if (this.props.percentage) {
      hasFormValue = true;
    } else {
      const { allFormsValid } = this.state;
      hasFormValue = this.checkFormsValid(allFormsValid);
    }
    return hasFormValue;
  };

  checkFormsValid = (formsValidArr) => {
    if (formsValidArr.length) {
      return formsValidArr.reduce((accumulator, currentValue) => accumulator && currentValue);
    }
    return false;
  }

  handleFormChange = (formState, key) => {
    const { formData, isFormValid } = formState;
    const tabIndex = key - 1;   
    const nonSelData = this.state.tabData.filter(i => i.selected === false);
    let updatedTabData = this.state.tabData.filter(i => i.selected === true).map((data, index) => {
      if (index === tabIndex) {
        return { ...data, ...formData };
      }
      return { ...data };
    });
    updatedTabData = [...updatedTabData, ...nonSelData];    
    const updatedFormsValid = [...this.state.allFormsValid];
    updatedFormsValid[tabIndex] = isFormValid;    
    this.props.saveSuccessorValues({
      successorInfo: updatedTabData,
      key: this.props.contentKey
    });
    this.setState({
      tabData: updatedTabData,
      allFormsValid: updatedFormsValid
    });
  }
  renderCharityIncrementButton = (legacyValues = [], count) => {
    const planDetails = JSON.parse(JSON.stringify(legacyValues));
    legacyValues = legacyValues.filter(i => i.selected === true);
    return (
      <div data-test="renderCharityIncrementButtonBlock">
        {legacyValues.length < 20 &&
          legacyValues.length > 1 ? (
            <div>
              <PillButtonAddSpaceAdd>
                <CapsuleButton
                  data-test="CharityIncrementremoveCapsuleButton"
                  text="Remove Charity -"
                  width="227px"
                  lineHeight="1.25rem"
                  onClick={this.onRemove}
                  id={"btn"+this.props.contentKey+"RemoveCharity"+count}
                  />
              </PillButtonAddSpaceAdd>
              <CapsuleButton
                data-test="CharityIncrementaddeCapsuleButton"
                text="Add Charity"
                iconType="add"
                width="227px"
                lineHeight="1.25rem"
                id={"btn"+this.props.contentKey+"AddCharity"+count}
                onClick={e => this.handleAddSuccessor(this.props.contentKey, planDetails)}
              />
            </div>
          ) : legacyValues.length >= 20 ? (
            <>
              <CapsuleButton
                data-test="CharityIncrementRemoveCapsuleButton"
                text="Remove Charity -"
                width="227px"
                lineHeight="1.25rem"
                onClick={this.onRemove}
                id={"btn"+this.props.contentKey+"RemoveCharity"+count}
              />
              <DataHeading className="my-30">
                Please contact VC to add additional organizations to your plan
            </DataHeading>
            </>
          ) : (
            <CapsuleButton
             data-test="CharityIncrementAddCapsuleButton"
              text="Add Charity"
              iconType="add"
              width="227px"
              lineHeight="1.25rem"
              id={"btn"+this.props.contentKey+"AddCharity"+count}
              onClick={e => this.handleAddSuccessor(this.props.contentKey, planDetails)}
              />
              )}
          </div>
        );
  }

  renderSuccessorInc = (legacyValues, count) => {    
    const planDetails = JSON.parse(JSON.stringify(legacyValues));
    legacyValues = legacyValues.filter(i => i.selected === true);    
    return (
    <>
        {this.props.head.includes("two successor") ? (
          legacyValues.length <= 1 ? (
            <CapsuleButton
              data-test="renderSuccessorIncAddCapsuleBtn"
              text="Add Successor Account"
              iconType="add"
              width="227px"
              lineHeight="1.25rem"
              id={"btn"+this.props.contentKey+"AddSuccessorAccount"+count}
              onClick={e => this.handleAddSuccessor(this.props.contentKey, planDetails)}
            />
            ) : (
              <CapsuleButton
              data-test="renderSuccessorIncRemoveCapsuleBtn"
                text="Remove Successor Account -"
                width="227px"
                lineHeight="1.25rem"
                id={"btn"+this.props.contentKey+"RemoveSuccessorAccount"+count}
                onClick={this.onRemove}
              />
            )
        ) : legacyValues.length < 6 &&
          legacyValues.length > 1 ? (
              <div>
                <PillButtonAddSpaceAdd>
                  <CapsuleButton
                    text="Remove Successor Account -"
                    width="227px"
                    lineHeight="1.25rem"
                    id={"btn"+this.props.contentKey+"RemoveSuccessorAccount"+count}
                    onClick={this.onRemove}
                  />
                </PillButtonAddSpaceAdd>
                {(legacyValues.length === 2 && this.props.optionId === 1) ? '' : 
                (
                  <CapsuleButton
                    text="Add Successor Account"
                    iconType="add"
                    width="227px"
                    lineHeight="1.25rem"
                    id={"btn"+this.props.contentKey+"AddSuccessorAccount"+count}
                    onClick={e => this.handleAddSuccessor(this.props.contentKey, planDetails)}
                  />
                )
                }
              </div>
            ) : legacyValues.length === 6 ? (
              <>
                <CapsuleButton
                  text="Remove Successor Account - "
                  width="227px"
                  lineHeight="1.25rem"
                  id={"btn"+this.props.contentKey+"RemoveSuccessorAccount"+count}
                  onClick={this.onRemove}
                />
                <DataHeading className="my-30">
                  Please contact VC to add additional successors
            </DataHeading>
            </>
            ) : (
              <CapsuleButton
                text="Add Successor Account"
                iconType="add"
                width="227px"
                lineHeight="1.25rem"
                id={"btn"+this.props.contentKey+"AddSuccessorAccount"+count}
                onClick={e => this.handleAddSuccessor(this.props.contentKey, planDetails)}
              />
              )}
      </>
    )
  }

  render() {
    const legacyValues = this.state.tabData;
    const { remove, show, showFormValidation, indexValue } = this.state;
    const filteredLegacyValues = legacyValues && legacyValues.filter(i => i.selected === true);    
    return (
      <div>
        {remove === true ? (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={this.removePopupContent}
            closeModal={this.closeModalInside}
            handleRemove={this.handleRemoveModal}
          />
        ) : null}
        {show === true ? (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={
              this.props.contentKey === "multiCharity"
                ? this.removePopupContentCharity
                :this.removePopupContentAppoint 
            }
            closeModal={this.closeModal}
            handleRemove={this.handleRemove}
          />
        ) : null}
        <TabsWrapper id={this.props.contentKey} tabActiveKey={this.state.activeKey}>
          <Tabs
            tabPosition="top"
            onChange={this.onChange}
            activeKey={this.state.activeKey}
            type="card"
          >
            {filteredLegacyValues &&
              filteredLegacyValues.map((data, index) => {
                let count = index + 1;                
                return (
                  <TabPane
                    key ={index}
                    tab={
                      this.props.optionId === 1 ? (
                        <TitleWrap>Successor {count}</TitleWrap>
                      ) : this.props.optionId === 2 ? (
                        <TitleWrap>Successor Account {count}</TitleWrap>
                      ) : (
                            <TitleWrap>Charity {count}</TitleWrap>
                          )
                    }
                    key={count}
                  >
                    {this.props.optionId === 1 || this.props.optionId === 2 ?
                      <>
                        <Form
                          selectedPlans={this.props.selectedPlans}
                          optionId={this.props.optionId}
                          data={data}
                          handleChange={this.props.handleChange}
                          contentKey={this.props.contentKey}
                          successorKey={count}
                          handleFormChange={this.handleFormChange}
                          validateForm={showFormValidation}
                          legacyFormValid= {this.props.legacyFormValid}
                        />
                        {this.renderSuccessorInc(legacyValues, count)}
                      </>
                      :
                      <>
                        <CharityForm
                          data-test="CharityFormTest"
                          data={data}
                          handleChange={this.props.handleChange}
                          contentKey={this.props.contentKey}
                          successorKey={count}
                          handleFormChange={this.handleFormChange}
                          validateForm={showFormValidation}
                          charityTotalPercent={this.state.charityAllocPercent}
                          legacyFormValid= {this.props.legacyFormValid}
                        />
                        {this.renderCharityIncrementButton(legacyValues, count)}
                      </>
                    }
                    {indexValue ? (
                      <>
                        <Err>The successor advisor {_.uniq(invalidTab).toString()} cannot match an existing account advisor. Please select another successor advisor.</Err>
                      </>
                    ) : ''}
                    {this.checkFields() ? (
                      <PillButtonGreenWrap>
                    <CapsuleButton data-test={`SandC${index}`} text="Save and Continue" styles="pill-button-green" onClick={() => this.handleSave(legacyValues)} id={"btn"+this.props.contentKey+"SaveAndContinue"+count} mobWidth="170px" />
                        <UnderlinelinkRemove
                          onClick={this.handleRemoveState}
                          className="inline-block"
                          id={"anr"+this.props.contentKey+"Remove"+count}
                        >
                          Remove
                    </UnderlinelinkRemove>
                      </PillButtonGreenWrap>
                    ) : (
                        <ShowLessWrapMargin>
                          <CapsuleButton
                            text="Show Less"
                            onClick={this.props.handleChange}
                            id={"btn"+this.props.contentKey+"ShowLess"+count}
                            whiteBackground
                            iconType="arrowUp"
                            width="135px"
                            mobWidth="135px"
                          />
                        </ShowLessWrapMargin>
                      )}
                  </TabPane>
                );                
              })}
          </Tabs>
        </TabsWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  accountAdvisors: state.getIn([
    "myAccount",
    "accountData",
    "data",
    "accountAdvisors"
  ]),    
  percentage: state.getIn([
    "myAccount",
    "legacyValues",
    `${ownProps.contentKey}`,
    "assignedPercentage"
  ]).toString(),
  successorData: state.getIn([
    "myAccount",
    "legacyValues",
    `${ownProps.contentKey}`,
    "successorAdvisor"
  ]),
  charityData: state.getIn([
    "myAccount",
    "legacyValues",
    `${ownProps.contentKey}`,
    "successionPlanGranteeOrg"
  ]),

  legacyFormValid: state.getIn([ "myAccount",
  "legacyFormValid",
  `${ownProps.contentKey}`
  ])
});

export const mapDispatchToProps = dispatch => ({
  errorVariable: val => dispatch(errorVariable(val)),
  saveOptionData: val => dispatch(saveOptionData(val)),
  addSuccessor: val => dispatch(addSuccessor(val)),
  resetLegacy: val => dispatch(resetLegacy(val)),
  saveSuccessorValues: val => dispatch(saveSuccessorValues(val)),
  shouldClose: val => dispatch(shouldClose(val)),
  showRemainingPercentage: val => dispatch(showRemainingPercentage(val)),
  updateLegacyFormValid: val => dispatch(updateLegacyFormValid(val))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabsComponent);
